export const APP_NAME = 'Lilia'
export const REDIRECT_URL_KEY = 'redirectUrl'
